<template>
  <div :class="{'opacity-50 cursor-not-allowed': ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11'}">
    <div>
      <div v-if="isLeader" class="flex items-center px-4 py-2 my-4 rounded-md shadow-md" style="background: white">
        <i
          class="sp-icon-file-code-warning-1 text-gray relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"
        ></i>
        <div class="text-grey text-sm font-medium">{{ $t("ecosystem.team_info_msg")}}</div>
      </div>
    </div>

    <h2
      class="text-red text-lg text-bold mb-3 pb-2 border-red-light border-b"
      v-if="isLeader && ecosystemApp.application.status == '0'"
    >{{ $t("team.inviteMember") }}</h2>

    <div class="px-4 py-3 mt-0">
      <!-- Add section succes message sent invitation member -->
      <div
        v-if="msg_success != ''"
        class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
        role="alert"
      >{{ msg_success }}</div>

      <!-- Loader -->
      <loader v-if="loading" :center="true"></loader>

      <!-- form -->

      <div v-if="loading == false && ecosystemApp.application.status=='0' ">
        <!-- Alert -->
        <div
          v-if="this.msg_error && isLeader && ecosystemApp.application.status=='0'"
          class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-5"
          role="alert"
        >
          <p>
            <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
          </p>
          <ul
            class="error-messages block sm:inline text-left pr-2 list-reset"
            v-html="this.msg_error"
          ></ul>
          <a
            v-if="resend_invitation_member"
            @click="sendInvitation(false,true)"
            class="cursor-pointer"
          >{{ $t("form.resend_invit") }}</a>
        </div>
        <div
          v-else-if="status_teams == false && isLeader && ecosystemApp.application.status=='0'"
          class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-5"
          role="alert"
        >
          <p>
            <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
          </p>
          <ul
            class="error-messages block sm:inline text-left p-0 list-reset"
            v-html="this.msg_error_lead"
          ></ul>
        </div>
        <div class="text-right pt-2" v-if="isLeader && ecosystemApp.application.status=='0'">
          <div class="flex form-group w-full text-left mb-6">
            <label class="font-serif w-1/3">{{ $t("team.addMember") }}</label>
            <input
              autocomplete="off"
              v-model="email"
              id="email"
              type="text"
              placeholder="Email"
              name="email"
              min="0"
              max
              class="border border-grey rounded w-2/3 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
            />
          </div>
          <button
            v-if="ecosystemApp.application && ecosystemApp.application.status=='0'"
            class="text-right no-underline font-medium text-2sm p-2 rounded focus:outline-none focus:shadow-outline transition-all text-white border border-blue bg-blue shadow-lg hover:bg-white hover:text-blue mt-1"
            @click="sendInvitation(false,false)"
          >
            <i class="fa fa-paper-plane mr-2"></i>
            {{ $t("team.sendMail") }}
          </button>
        </div>
      </div>
    </div>

    <h2 class="text-red text-lg text-bold pb-2 border-red-light border-b">{{ $t("team.team") }}</h2>

    <div class="table-responsive">
      <table class="table table-hover border-separate p-4">
        <thead>
          <tr class="text-sm text-grey font-normal w-full">
            <th scope="col" class="w-1/4">{{ $t("team.nameComplete") }}</th>
            <th scope="col" class="w-1/4">{{ $t("team.email") }}</th>
            <th scope="col" class="w-1/4">{{ $t("team.role") }}</th>
            <th scope="col" class="w-1/4">{{ $t("team.status") }}</th>
            <th scope="col" class="w-1/4 text-center" v-if="isLeader">{{ $t("team.actions") }}</th>
          </tr>
        </thead>
        <tbody class="w-full p-1">
          <tr
            class="w-full bg-white text-2sm text-grey-darker"
            v-for="(team, index) in ecosystemTeam"
            :key="index"
          >
            <td
              class="w-1/4 rounded-l-sm border-t border-b border-l p-4"
            >{{ team.name }} {{ team.last_name }}</td>
            <td class="w-1/4 border-t border-b text-2sm text-grey-darker p-4">{{ team.email }}</td>
            <td class="w-1/4 border-t border-b text-2sm text-grey-darker p-4" v-if="team.role != null">
              {{ team.role }}
              <span
                class="lead"
                v-if="ecosystemApp.application.user_id == team.user_id"
              >(Lead)</span>
            </td>
             <td class="w-1/4 border-t border-b text-2sm text-grey-darker p-4" v-if="team.role == null">
              N/A
            </td>
            <td class="w-1/4 border-t border-b text-2sm text-grey-darker p-4">
              <div class="form-control relative">
                <span v-if="team.status == 1 && ecosystemApp.application.user_id != team.user_id && !team.role">
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-member-info-missing"
                  ></i>
                </span>
                <span v-if="team.status == 0 && ecosystemApp.application.user_id != team.user_id">
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-pending"
                  ></i>
                </span>
                <span v-if="team.status == 1 && ecosystemApp.application.user_id != team.user_id && team.role">
                  <i
                    class="relative block md:inline-block w-5 h-5 mx-auto md:mr-3 text-xl text-white icon icon-check-green"
                  ></i>
                </span>
                <span v-if="ecosystemApp.application.user_id == team.user_id">Lead</span>
              </div>
            </td>
            <td class="w-2/4 rounded-r-sm border-t border-b border-r p-4">
              <div
                class="flex justify-end"
                v-if="ecosystemApp.application.status=='0' || ecosystemApp.application.status=='11'"
              >
                <div class="mx-3 text-center" v-if="isLeader && ecosystemApp.application.user_id != team.user_id && team.status == '1' || isLeader && ecosystemApp.application.user_id == team.user_id ">
                  <router-link
                    class="text-grey text-sm opacity-75 no-underline transition-all hover:opacity-100"
                    :to="{
                      name: 'team-edit',
                      params: { team_id: team.user_id, app_id: $route.params.app_id }
                    }"
                  >
                    <i class="fas fa-pencil-alt mr-2"></i>
                    {{ $t("team.editMember") }}
                  </router-link>
                </div>
                <div class="mx-3 text-center" v-if="isLeader && (team.user_id != ecosystemApp.application.user_id)">
                  <router-link
                    class="text-grey text-sm opacity-75 no-underline transition-all hover:opacity-100"
                    :to="{
                      name: 'team-delete',
                      params: { team_id: team.user_id, app_id: $route.params.app_id }
                    }"
                  >
                    <i class="fas fa-trash-alt mr-2"></i>
                    {{ $t("team.deleteMember") }}
                  </router-link>
                </div>
                <div class="mx-3 text-center" v-if="isLeader && (ecosystemApp.application.user_id != team.user_id) && team.status == 0">
                  <a
                    class="text-grey text-sm opacity-75 no-underline transition-all hover:opacity-100 cursor-pointer"
                    @click="sendInvitation(team,true)"
                  >
                    <i class="fas fa-sync-alt mr-2"></i>
                    {{ $t("team.resend_member_invit") }}
                  </a>
                </div>

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Fragment } from "vue-fragment";
import Loader from "@/components/Loader.vue";
import { GET_ECOSYSTEM_TEAM, SEND_ECOSYSTEM_INVITATION, FETCH_ECOSYSTEM_APPLICATION, GET_ECOSYSTEM_APP_CHECKLIST } from "@/store/actions.type";
import { SET_ECOSYSTEM_MENU_ACTIVE, SET_PROGRESS } from "@/store/mutations.type";
export default {
  name: "EcosystemTeam",
  components: {
    "fragment": Fragment,
    Loader
  },
  data() {
    return {
      inProgress: false,
      email: "",
      msg_error: "",
      msg_success: [],
      loading: false,
      isLeader: true,
      resend_invitation_member: false,
      status_teams: null,
      msg_error_lead: null
    }
  },
  methods: {
    fetchTeams(){
      this.$store
        .dispatch(GET_ECOSYSTEM_TEAM, this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id)
        .then(data => {
          if (data.data.pended_invited_users.length > 0) {
            if (this.isLeader) {
                this.msg_error = this.$t("team.validated_account");
            }
            data.data.pended_invited_users.forEach(pended_member => {
                var namePended = "N/A";
                var last_namePended = "";
                if (pended_member.name) {
                    namePended = pended_member.name;
                }
                if (pended_member.last_name) {
                    last_namePended = pended_member.last_name;
                }
                var add_pended_user = {
                    name: namePended,
                    last_name: last_namePended,
                    role: "N/A",
                    user_id: pended_member.email,
                    id: pended_member.email,
                    status: pended_member.status,
                    email: pended_member.email
                };
                this.ecosystemTeam.push(add_pended_user);
            });
          }else{
              if (this.isLeader) {
                  if (data.data.teams.length > 1) {
                    var complete_infos =  true;
                    data.data.teams.forEach(member => {
                        if (member.cin_number == null && member.user_id != this.ecosystemApp.user_id) {
                            complete_infos =  false;
                        }
                    });
                    this.$store
                        .dispatch(GET_ECOSYSTEM_APP_CHECKLIST, this.$route.params.app_id)
                        .then(({ data }) => {
                            this.status_teams = data.data.teams;
                            if (data.data.teams == false) {
                                if(complete_infos == false){
                                    this.msg_error = this.$t("team.sso_complete_infos");
                                }else{
                                    this.msg_error = this.$t("team.validated_account");
                                }
                            } else {
                                this.msg_error_lead = null;
                            }
                        });
                }else {
                      if (data.data.teams[0].cin_number == null && this.session && this.session.startup_application && data.data.teams[0].user_id == this.session.startup_application.user_id) {
                          this.msg_error = this.$t("team.sso_complete_infos");
                      }
                }
              }
          }

          if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          this.currentUser &&
          this.ecosystemApp.application.user_id != this.currentUser.id
        ) {
          this.isLeader = false;
        }
        });
    },
    sendInvitation(member, resend) {
      this.msg_error = "";
      if (member) {
        // Case resend invitation mail //
        this.email = member.email;
      }
      this.$store
        .dispatch(SEND_ECOSYSTEM_INVITATION, {
          hashId: this.ecosystemApp.application.hash_id ||this.ecosystemApp.application.id,
          email: this.email,
          resend: resend
        })
        .then(data => {
          this.msg_success = data.meta.messages[0];
          if (!resend) {
            // Fetch teams again to add new user synchronously only if invitation sent to inexistent user
            this.$store
              .dispatch(GET_ECOSYSTEM_TEAM, this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id)
              .then(data2 => {
                // Add pended users to Team
                if (data2.data.pended_invited_users) {
                  data2.data.pended_invited_users.forEach(pended_member => {
                    var namePended = "N/A";
                    var last_namePended = "";
                    if (pended_member.name) {
                      namePended = pended_member.name;
                    }
                    if (pended_member.last_name) {
                      last_namePended = pended_member.last_name;
                    }
                    var add_pended_user = {
                      name: namePended,
                      last_name: last_namePended,
                      role: "N/A",
                      user_id: pended_member.email,
                      id: pended_member.email,
                      status: pended_member.status,
                      email: pended_member.email
                    };
                    this.ecosystemTeam.push(add_pended_user);
                  });
                }
              })
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (
            error.response.data.meta.messages[0] ==
            this.$t("team.invitation_sent")
          ) {
            this.resend_invitation_member = true;
          }
          this.msg_error = error.response.data.meta.messages[0];
        });
    }
  },
  mounted() {
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    this.$store
      .dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id)
      .then(() => {
        this.fetchTeams();
      })
      .catch(() => {
        this.$router.push({ name: "home" });
      });
  },
  computed: {
    ...mapGetters(["currentUser", "ecosystemApp", "ecosystemTeam"])
  },
  beforeDestroy() {
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
  }
}
</script>

<style>
  table.border-separate {
    border-spacing: 0 10px;
  }
  table.border-separate tbody tr {
    box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
    border-radius: 4px;
  }
  table.border-separate tbody tr:hover {
    box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
  }

  .table.border-separate tbody td {
    vertical-align: middle;
    border-color: rgba(29, 57, 100, 0.13);
  }
  .table.border-separate tbody tr:hover td {
    border-color: rgba(29, 57, 100, 0.23);
  }

  .table.border-separate thead th,
  .table.border-separate thead td {
    border: none;
  }

  .lead {
    height: 20px;
    width: 58px;
    opacity: 0.5;
    color: #1d3964;
    font-family: Roboto;
    font-size: 14px;
    line-height: 20px;
  }

  .icon.icon-check-green::before {
  background-image: url("../../assets/img/check_green.svg");
  }

  .icon.icon-pending::before {
    background-image: url("../../assets/img/pending.svg");
  }
  
  .icon.icon-member-info-missing::before {
    background-image: url("../../assets/img/member-info-missing.svg");
  }
</style>